import { defineMessages } from 'react-intl-next';

export const i18n: {
    lastUpdated: {
        id: string;
        defaultMessage: string;
        description: string;
    };
} = defineMessages({
	lastUpdated: {
		id: 'search-page.filters.names.lastUpdated',
		defaultMessage: 'Last updated',
		description: 'Label for filtering by last updated time',
	},
});
